module.exports = __webpack_public_path__ + "media/images/mixture_image-eb6571d2.png";